"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preprocessHtmlContent = void 0;
var videoEmbed_1 = require("@/utils/videoEmbed");
/**
 * Preprocess HTML content to replace </p> <p> with <br> and all empty <p> tags with <br>.
 * @param {string} content - The HTML content to preprocess.
 * @returns {string} - The preprocessed HTML content.
 */
exports.preprocessHtmlContent = function (content) {
    // Null/undefined content (e.g. agents with no biography) must not crash SSR.
    if (!content)
        return '';
    // Rebuild the Content Tool video blocks first: the sanitizer strips their iframe, so the
    // wrapper arrives empty and the empty-<div> rule below would otherwise collapse it to <br>.
    var updatedContent = videoEmbed_1.renderVideoEmbeds(content);
    // Replace empty <div></div> tags (with or without attributes) with <br>
    updatedContent = updatedContent.replace(/<div[^>]*>\s*<\/div>/g, '<br>');
    // Replace empty <p> tags with <br>, handling attributes and whitespace
    updatedContent = updatedContent.replace(/<p[^>]*>\s*(?:&nbsp;|\u00A0)?\s*<\/p>/g, '<br>');
    return updatedContent;
};
